// auth.js
export const CHANGE_TITLE = "CHANGE_TITLE";

export const LOAD_CONFIG = "LOAD_CONFIG";
export const SET_LOADER = "SET_LOADER";

export const SET_LOCALE = "SET_LOCALE";
